/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  // document.addEventListener('theme:variant:change', function(event) {
  //   // You might use something like this to write a pre-order feature or a
  //   // custom swatch feature.
  //   var variant = event.detail.variant;
  //   var container = event.target;
  //   if (variant) {
  //     console.log('Container ———————— ↓');
  //     console.log(container);
  //     console.log('Variant —————————— ↓');
  //     console.log(variant);
  //     // ... update some element on the page
  //   }
  // });

  // document.addEventListener('theme:cart:change', function(event) {
  //   var cart = event.detail.cart;
  //   if (cart) {
  //     console.log('Cart ———————————— ↓');
  //     console.log(cart);
  //     // ... update an app or a custom shipping caluclator
  //   }
  // });
  // Fired when page loads to update header values
  // document.addEventListener('theme:cart:init', (e) => {
  //   console.log('theme:cart:init');
  //   console.log(e);
  // });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  // document.addEventListener('theme:scroll', e => { console.log(e); });
  // document.addEventListener('theme:scroll:up', e => { console.log(e); });
  // document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  // document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));

  document.addEventListener("DOMContentLoaded", function () {
    const selectField = document.getElementById("gift-note-suggestions-select");
    const textArea = document.getElementById("gift-note-text-area");

    if(selectField){
        selectField.addEventListener("change", function () {
        const selectedValue = selectField.value;
        textArea.value = selectedValue;
  
        const inputEvent = new Event("input", { bubbles: true });
        textArea.dispatchEvent(inputEvent);
      });
    }

    window.addEventListener('scroll', function() {
      if (window.scrollY > 0) {
        document.body.classList.add('sticky-header-on');
      } else {
        document.body.classList.remove('sticky-header-on');
      }
    });

    // Cushion count sync
    const debounce = (fn, wait) => {
      let timeoutId;
      return (...args) => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => fn.apply(null, args), wait);
      };
    };

    function computeCushionCountFromDom(root = document) {
      const rows = root.querySelectorAll('[data-cart-item][data-has-cushion="true"]');
      let total = 0;
      rows.forEach((row) => {
        const qtyInput = row.querySelector('[data-quantity-input]');
        const qty = qtyInput ? parseInt(qtyInput.value, 10) : 0;
        if (!Number.isNaN(qty)) total += qty;
      });
      return total;
    }

    const updateCartCushionAttribute = debounce((count) => {
      try {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { cushion_count: String(count) } })
        });
      } catch (e) {
        // no-op
      }
    }, 300);

    function resyncCushionCount() {
      const count = computeCushionCountFromDom();
      updateCartCushionAttribute(count);
    }

    // Initial sync on load (cart page only if present)
    if (document.querySelector('[data-section-type="cart"]')) {
      resyncCushionCount();
    }

    // Theme cart events if available
    document.addEventListener('theme:cart:init', resyncCushionCount, { passive: true });
    document.addEventListener('theme:cart:change', resyncCushionCount, { passive: true });

    // Quantity changes
    document.addEventListener('change', function (e) {
      if (e.target && e.target.matches('[data-quantity-input]')) {
        resyncCushionCount();
      }
    }, true);

    // Removes
    document.addEventListener('click', function (e) {
      const el = e.target.closest('[data-remove-key]');
      if (el) {
        // after DOM refresh, observer below will also re-run as fallback
        setTimeout(resyncCushionCount, 400);
      }
    }, true);

    // Rebuy cart changes (if present)
    document.addEventListener(
      "rebuy:cart.change",
      (event) => {
        const cartItems = event.detail.cart.cart.items;
        const cartAttributes = event.detail.cart.cart.attributes;
        const cartAttributeCount = event.detail.cart.cart.attributes.cushion_count || 0;

        const cushionCount = cartItems
          .filter((item) => item.title.toLowerCase().includes("cushion"))
          .reduce((total, cushion) => total + cushion.quantity, 0);

          if (cushionCount != cartAttributeCount) Rebuy.Cart.updateItem({attributes: {...cartAttributes, cushion_count: cushionCount}})
      }
    );

    // Mutation observer on line items container
    const lineItems = document.querySelector('[data-line-items]');
    if (lineItems) {
      const observer = new MutationObserver(() => {
        resyncCushionCount();
      });
      observer.observe(lineItems, { childList: true, subtree: true });
    }
  });

  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();
